import React from 'react'
import { AnalysisSummary as AnalysisItem } from '../../../services/api'
import { View, matchesView, daysUntil } from './helpers'

function Metric({ value, label, color, onClick }: {
  value: string | number; label: string; color: string; onClick?: () => void
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!onClick}
      className="flex-1 flex flex-col items-center gap-1 py-3.5 px-2 rounded-lg border border-an-line bg-an-surface transition-all"
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <span className="text-[22px] font-bold tracking-[-0.03em] leading-none" style={{ color }}>{value}</span>
      <span className="text-[11px] text-an-ink-3 font-medium text-center leading-tight">{label}</span>
    </button>
  )
}

export function StatusStrip({ items: allItems, onSelectView }: { items: AnalysisItem[]; onSelectView: (v: View) => void }) {
  const items = allItems.filter(i => i.is_relevant !== false)
  const actionPending = items.filter(i => matchesView(i, 'attention')).length
  const urgent = items.filter(i => {
    const d = daysUntil(i.compliance_deadline)
    return d >= 0 && d <= 90 && i.review_status !== 'dismissed'
  }).length
  const total = items.filter(i => i.review_status !== 'dismissed').length
  const reviewed = items.filter(i => i.review_status === 'accepted' || i.review_status === 'rejected' || i.review_status === 'informational').length
  const pct = total > 0 ? Math.round((reviewed / total) * 100) : 0

  return (
    <div className="grid grid-cols-4 gap-2">
      <Metric
        value={actionPending}
        label={actionPending === 1 ? 'needs action' : 'need action'}
        color="var(--an-red)"
        onClick={() => onSelectView('attention')}
      />
      <Metric
        value={urgent}
        label={urgent === 1 ? 'deadline ≤ 90d' : 'deadlines ≤ 90d'}
        color="var(--an-amber)"
      />
      <Metric
        value={`${pct}%`}
        label="reviewed"
        color="var(--an-ink-2)"
        onClick={() => onSelectView('reviewed')}
      />
      <Metric
        value={total}
        label="active"
        color="var(--an-accent)"
      />
    </div>
  )
}
